<template>
  <v-snackbar
    :value="notification"
    :color="notificationType"
    top
    right
    @input="onCloseOrDismiss"
    :timeout="2000"
    class="unmarkable"
  >
    {{ notificationText }}
    <v-btn icon @click="onCloseOrDismiss">
      <v-icon color="white">close</v-icon>
    </v-btn>
  </v-snackbar>
</template>
<script>
import {
  GET_NEXT_NOTIFICATION,
  EMPTY_CURRENT_NOTIFICATION
} from "../../store/modules/notifications/constants.js";
const _ = require("lodash");

export default {
  name: "NotificationCenter",
  data: function() {
    return {
      notification: false,
      notificationText: "",
      notificationType: ""
    };
  },
  computed: {
    currentNotification() {
      return this.$store.state.notifications.currentNotification;
    },
    pendingNotifications() {
      return this.$store.state.notifications.pendingNotifications;
    }
  },
  watch: {
    currentNotification: {
      immediate: true,
      handler(newCurrentNotification) {
        if (!_.isEmpty(newCurrentNotification)) {
          this.notificationText = newCurrentNotification.message;
          this.notificationType = newCurrentNotification.priority;
          this.notification = true;
        } else {
          this.$store.dispatch(GET_NEXT_NOTIFICATION);
        }
      }
    },
    pendingNotifications() {
      this.$store.dispatch(GET_NEXT_NOTIFICATION);
    }
  },
  methods: {
    onCloseOrDismiss() {
      this.notification = false;
      setTimeout(() => {
        this.$store.dispatch(EMPTY_CURRENT_NOTIFICATION);
      }, 100);
    }
  }
};
</script>
<style></style>
